/* eslint-disable react/no-unknown-property */
import { Html } from '@react-three/drei';
import classNames from 'classnames';
import { PointerEventHandler, useEffect } from 'react';
import Styles from './style.module.scss';
import gsap from 'gsap';

type Props = {
  name: string;
  position: Array<number>;
  status?: boolean;
  colorIndex?: number;
  //orbit?: any;
  oclusionObj: any;
  setButtonAction?: PointerEventHandler<HTMLButtonElement>;
};

const MarkerParent = ({
  name,
  position,
  status = false,
  colorIndex = 0,
  oclusionObj,
  setButtonAction = () => {},
}: Props) => {
  return (
    <group>
      {/* <TransformControls ref={transform}> */}
      <mesh name={name}>
        <Html sprite position={[position[0], position[1], position[2] + 0.3]}>
          <div
            id={'marker'}
            style={{ display: status ? 'block' : 'none' }}
            className={Styles.wrapper}
          >
            <button
              id={'markButton'}
              className={classNames(
                Styles.button,
                {
                  [Styles.sky]: colorIndex === 0,
                },
                {
                  [Styles.green]: colorIndex === 1,
                },
                {
                  [Styles.steel]: colorIndex === 2,
                },
                {
                  [Styles.gray]: colorIndex === 3,
                }
              )}
              onPointerUp={setButtonAction}
            >
              <p id={'plusMark'} className={Styles.symbol}>
                {'+'}
              </p>
            </button>
            <span
              className={classNames(
                Styles.animateEffect,
                {
                  [Styles.sky]: colorIndex === 0,
                },
                {
                  [Styles.green]: colorIndex === 1,
                },
                {
                  [Styles.steel]: colorIndex === 2,
                },
                {
                  [Styles.gray]: colorIndex === 3,
                }
              )}
            ></span>
          </div>
        </Html>
      </mesh>
      {/* </TransformControls> */}
    </group>
  );
};

export default MarkerParent;
